import { type OfferV11 } from '@redteclab/api/clients/bully'

const BEST_PRICE = 'bestPrice'

export const productAccessorGetBestPriceOffer = ({
  offers,
}: {
  offers: OfferV11[] | undefined
}): OfferV11 | undefined => {
  return offers?.find((offerData) =>
    // @ts-expect-error TODO missing types on contract
    offerData.offerFlags?.includes(BEST_PRICE),
  )
}
